import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mailing-list-subscribe',
  templateUrl: './mailing-list-subscribe.component.html',
  styleUrls: ['./mailing-list-subscribe.component.css']
})
export class MailingListSubscribeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
